module.exports = require("./chr.d.ts");